
require('cd-owlcarousel');

$('.best-ratings > .items, .reviews > .items, .home-best-sellers > .items').each( function() {
    $(this).owlCarousel({
        items: 1,
        autoPlay: false,
        navigation: false,
        pagination: true,
        responsive: true,
        transitionStyle : "fade",
        itemsDesktopSmall: [1199,1],
        itemsTablet: [959,1],
        itemsTabletSmall: [899,1],
        itemsMobile: [480,1]
    });
});

// related products and related posts carousel
$('.related-posts > .items, .related-products > .items, .new-arrivals > .items, .best-sellers > .items').each( function() {
    $(this).owlCarousel({
        items: 4,
        autoPlay: false,
        navigation: false,
        pagination: true,
        responsive: true,
        itemsDesktopSmall: [1199,3],
        itemsTablet: [959,2],
        itemsTabletSmall: [899,3],
        itemsMobile: [480,1]
    });
});

$('.widget.widget-posts-carousel > .items, .widget-catalog-carousel > .items, .widget-testimonials-carousel > .items, .widget_portfolio > .items, .widget_our_team > .items').each( function() {
    var self = $(this);

    $(this).owlCarousel({
        items: 1,
        navigation: true,
        pagination: false,
        responsive: true,
        transitionStyle : "fade",
        itemsDesktopSmall: [1199,1],
        itemsTablet: [959,1],
        itemsTabletSmall: [899,1],
        itemsMobile: [480,1],
        afterInit: function( slider ) {
            $(slider).find('.owl-external .prev').click( function() {
                self.trigger('owl.prev');
            });
            $(slider).find('.owl-external .next').click( function() {
                self.trigger('owl.next');
            });
        }
    });
});

// change shop view list/grid
$('.change-shop-view').click( function() {

    var target = $('#shop-posts-list');

    $('a.change-shop-view').removeClass('current');

    if( $(this).hasClass('view-grid') ) {
        target.removeClass('view-list').addClass('view-grid');
    }

    if( $(this).hasClass('view-list') ) {
        target.removeClass('view-grid').addClass('view-list');
    }

    $(this).addClass('current');

    //ellipsis.reInit();

    return false;
});


// WEBPACK FOOTER //
// ./assets/javascript/sliders.js